import { useCheckUnpublishedChanges } from "../../api/workflowsApi";
import { Tooltip } from "@mui/material";

interface UnpublishedChangesIndicatorProps {
    workflowId: string;
}

const UnpublishedChangesIndicator = ({ workflowId }: UnpublishedChangesIndicatorProps) => {
    const { data, isLoading, error } = useCheckUnpublishedChanges(workflowId);
    
    // Don't show anything while loading or if there's an error
    if (isLoading || error) {
        return null;
    }
    
    // Only show indicator if there are unpublished changes
    if (!data?.has_unpublished_changes) {
        return null;
    }

    return (
        <Tooltip title="This workflow has unpublished changes" arrow>
            <div className="px-2 py-1 rounded-md bg-yellow-50 border border-yellow-200 text-yellow-700 text-xs font-medium">
                <span>Unpublished</span>
            </div>
        </Tooltip>
    );
};

export default UnpublishedChangesIndicator;

